module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAzUlEQVQ4T2NkIBMET/6k8Z+ZdTZj0IzvyQz/GWyIMefvf8alG7M49oA0MzCzLWf4+yuSMXjGj/N///8PJMaADy9fvBAWFlaAaV6by3eDMXj69/1rMzkdiTEA2WaQZpAeog3ApploA9A1B036JsPAyli/LpMzlaALsNkcMP27AjMDQ/3aTM5EggYETf0Zzvjv50WYn0HOJskAbIE7agC1AzFo2vfD67I4bYlJyjA1KLEQOP3HZsb//wQYGRn/EGvIfwYGEcb/DD1rszgXAgB7iaSzZQzXpwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/bianji.png
// module id = aI5Z
// module chunks = 96